/**
 * Per-section accent palette.
 *
 * Each ContentHub section (and a few standalone pages like Rewards, Library)
 * has a unique accent color that drives:
 *   - The vertical bar on its SectionHeader
 *   - Hero icons / badges
 *   - Hover states on its cards
 *
 * Picked to stay readable on the white background while
 * giving each page its own "fingerprint".
 *
 * Add a new entry whenever a new section is added.
 */

const PAGE_ACCENTS = {
  // ContentHub sections (matched by `/seccion/:slug`)
  library: "#1B2E7A",         // deep Canales blue (knowledge)
  procesos: "#0EA5A4",         // teal (operations / process)
  financiamiento: "#10B981",   // emerald (money / financing)
  motivacion: "#F97316",       // warm orange (energy / motivation)
  liderazgo: "#7C3AED",         // purple (leadership)
  estrategia: "#16A34A",        // green (strategy / growth)
  cultura: "#DB2777",            // pink (culture / community)

  // Standalone routes
  dashboard: "#1B2E7A",
  admin: "#1B2E7A",
  rewards: "#F4B81F",            // yellow (rewards / catalog)
  languages: "#0284C7",          // sky (languages)
  evaluations: "#1B2E7A",
  certificates: "#F4B81F",
  team: "#DC2626",
  settings: "#1B2E7A",

  default: "#1B2E7A",
};

export function getPageAccent(key) {
  if (!key) return PAGE_ACCENTS.default;
  return PAGE_ACCENTS[key] || PAGE_ACCENTS.default;
}

export default PAGE_ACCENTS;
